import { setGoToUrl } from '@chengla_web/cl_newutil'
export const onLine = location.origin.indexOf('://u.orangevip') >= 0
export const gloabHost = {
  u: setGoToUrl('u', process.env.VUE_APP_ENV)
}
// 存储localStorage时设置前缀
const storePrefix = 'CL_'
export function isWeiXin () {
  var ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}
// 判断手机号是否正确
export function isMobile (mobile) {
  let reg = /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/
  return reg.test(mobile)
}
// 密码校验规则(8-16位数字跟字母组合)
export function checkPass (password) {
  if (/\s/.test(password)) return false
  let passwordReq = /^(((?=.*[a-zA-Z])(?=.*\d)[^]{8,16})|((?=.*[^a-zA-Z0-9])(?=.*\d)[^]{8,16})|((?=.*[^a-zA-Z0-9])(?=.*[a-zA-Z])[^]{8,16}))$/
  let testResult = passwordReq.test(password)
  return testResult
}
// 图片验证码校验规则(4位数字跟字母组合)
export function checkImgCode (imgCode) {
  let imgCodeReq = /^[0-9a-zA-Z]{4}$/
  let testResult = imgCodeReq.test(imgCode)
  return testResult
}
// 验证用户名
export function checkName (nickName) {
  let nameReg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/u
  let testResult = nameReg.test(nickName)
  return testResult
}
// 存储localStorage
export const setLocalStore = (name, content) => {
  if (!name) return
  if (typeof content == 'object') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(storePrefix + name, content)
}

// 获取localStorage
export const getLocalStore = name => {
  if (!name) return
  var content = window.localStorage.getItem(storePrefix + name)
  return content
}

// 删除localStorage
export const removeLocaStore = name => {
  if (!name) return
  window.localStorage.removeItem(storePrefix + name)
}

// 存储sessionStorage
export const setSessStore = (name, content) => {
  if (!name) return
  if (typeof content == 'object') {
    content = JSON.stringify(content)
  }
  window.sessionStorage.setItem(storePrefix + name, content)
}

// 获取sessionStorage
export const getSessStore = name => {
  if (!name) return
  var content = window.sessionStorage.getItem(storePrefix + name)
  return content
}

// 删除sessionStorage
export const removeSessStore = name => {
  if (!name) return
  window.sessionStorage.removeItem(storePrefix + name)
}

/**
 * 解析url参数对象
 * @param url
 */
export function getUrlVars (url) {
  let hash
  let myJson = {}
  let hashes = url.slice(url.indexOf('?') + 1).split('&')
  for (let i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=')
    if (myJson.hasOwnProperty(hash[0])) {
      myJson[hash[0]] = myJson[hash[0]] + ',' + hash[1]
    } else {
      myJson[hash[0]] = hash[1]
    }
  }
  return myJson
}

/**
 * 创建网络请求对象
 */
export function createXHR () {
  var xhr
  xhr = new XMLHttpRequest() // W3C
  return xhr
}
/**
 *
 * @param {get, posst} method 请求方式
 * @param {*} url 请求url
 * @param {*} callback 回调函数
 */
export function syncRequest (method, url, data, callback) {
  let xhr = createXHR()
  xhr.open(method, url, false)
  xhr.withCredentials = true
  xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded; charset=utf-8')
  xhr.send(data)
  if (typeof callback === 'function') {
    if (xhr.status == 200) {
      callback(xhr.responseText)
    } else {
      console.log('获取数据错误，错误代码:' + xhr.status + '错误信息：' + xhr.statusText)
    }
  } else {
    return false
  }
}
/**
 * 选择图片并预览
 * @param {file控件} fileInput
 * @param {图片容器} imgDiv
 */
export function previewImg (fileInput, imgDiv) {
  if (window.FileReader) { // 支持FileReader的时候
    var reader = new FileReader()
    reader.readAsDataURL(fileInput.files[0])
    reader.onload = function (evt) {
      imgDiv.innerHTML = "<img style='width:100%;height:100%' src=" + evt.target.result + "\>"
    }
  } else { // 兼容ie9-
    imgDiv.innerHTML = '<div class="img" style="filter:progid:DXImageTransform.Microsoft.AlphaImageLoader(sizingMethod=scale,src=\'' + fileInput.value + '\)\';"></div>'
  }
}

/**
 * 解析url参数
 * @param param
 * @returns {*}
 */
export function getUrlParam (param) {
  let url = location.search // 获取url中"?"符后的字串
  let theRequest = {}
  if (url.indexOf('?') !== -1) {
    let str = url.substr(1)
    let strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = decodeURIComponent(
        strs[i].split('=')[1])
    }
  }
  if (theRequest[param]) {
    return theRequest[param]
  } else {
    return ''
  }
}
export function getUrlParamUrl (param, url) {
  if (!url) {
    url = location.search // 获取url中"?"符后的字串
  }
  let theRequest = {}
  if (url.indexOf('?') !== -1) {
    let _array = url.split("?")
    let str = _array[1]
    let strs = str.split('&')
    console.log(strs)
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = decodeURIComponent(
        strs[i].split('=')[1])
    }
  }
  if (theRequest[param]) {
    return theRequest[param]
  } else {
    return ''
  }
}
// 获取cookie
export function getCookie (name) {
  const arr = document.cookie.replace(/\s/g, '').split(';')
  for (let i = 0; i < arr.length; i++) {
    const tempArr = arr[i].split('=')
    if (tempArr[0] === name) {
      return decodeURIComponent(tempArr[1])
    }
  }
  return ''
}

// 设置cookie
export function setCookie (name, value, days = 7) {
  const date = new Date()
  if (days === 0) {
    document.cookie = name + '=' + value + ';path=/;domain=.orangevip.com'
  } else {
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    const expires = date.toUTCString()
    document.cookie = name + '=' + value + ';expires=' + expires + ';path=/;domain=.orangevip.com'
  }
}
/**
 * 判断是否为橙啦app
 * @returns {boolean}
 */
export function isClApp () {
  let ua = navigator.userAgent
  if (ua.match(/chengla_android/i)) {
    return true
  } else if (ua.match(/chengla_ios/i)) {
    return true
  } else {
    return false
  }
}
// 判断是否登录
// 最终确认CL_uid不存在则为未登录
// CL_uid存在，但CL_authcode||h5.orangevip.com都不存在则为未登录，存在其一则认为已登录
// 最终返回值 登录：false 未登录：true
export const needLogin = () => {
  if (isClApp()) {
    return !getCookie('clId')
  }
  if (isWeiXin()) {
    // 微信判断 getCookie('CL_is_wxauth')
    return !(getCookie('CL_uid') && (getCookie('CL_authcode') || getCookie('h5.orangevip.com')) && getCookie('CL_openId'))
  } else {
    return !(getCookie('CL_uid') && (getCookie('CL_authcode') || getCookie('h5.orangevip.com')))
  }
}

/**
 * 判断手机系统
 * @returns {string}
 */
export function mobileSystem () {
  const ua = navigator.userAgent
  if (ua.match(/chengla_android/i)) {
    return 'android'
  } else if (ua.match(/chengla_ios/i)) {
    return 'ios'
  } else {
    return ''
  }
}

export function Version (reqV) {
  let str = navigator.userAgent.toLowerCase()
  let ver = ''
  if (mobileSystem() == 'ios') {
    ver = str.split("chengla_ios_")
  } else {
    ver = str.split("chengla_android_")
    ver = ver[1].split("_")
  }
  let curV = ver[1].replace(/_/g, ".")
  if (!reqV) {
    reqV = '3.0.0'
  }
  let arr1 = curV.toString().split('.')
  let arr2 = reqV.toString().split('.')
  // 将两个版本号拆成数字
  let minL = Math.min(arr1.length, arr2.length)
  let pos = 0 // 当前比较位
  let diff = 0 // 当前为位比较是否相等
  let flag = false
  // 逐个比较如果当前位相等则继续比较下一位
  while (pos < minL) {
    diff = parseInt(arr1[pos]) - parseInt(arr2[pos])
    if (diff == 0) {
      pos++
      continue
    } else if (diff > 0) {
      flag = true
      break
    } else {
      flag = false
      break
    }
  }
  return flag
}



// WEBPACK FOOTER //
// ./src/common/js/until.js